import React from 'react';
import SEO from '@/SEO';

const HTML_CONTENT = `<h1>யஜூர் தர்பணம்</h1>
<div class="div3">
  யஜூர் வேதம் - ஆபஸ்தம்பம் - மஹாளயம் உள்ளிட்ட தர்பண மந்த்ரங்கள்
  விரிவாக வழங்கப்பட்டுள்ளன.
</div>
<mat-accordion>
  <mat-expansion-panel><mat-expansion-panel-header>
    ஆரம்பம் - சங்கல்பம்வரை</mat-expansion-panel-header>
<div class="div3">
                <span class="hint">யஜூர் வேதம் - ஆபஸ்தம்பம் - மஹாளயம் உள்ளிட்ட
                    தர்பண மந்த்ரங்கள்</span>
            
                <span style="color: Navy">2ஆசமனம் பண்ணி 3 பில் பவித்ரம், 3பில் ஆசனம், 3 இடுக்குப்பில்லுடன்
                    ப்ராணாயாமம். </span>
           
                <span style="color: Red">வடகலையார் மட்டும்:</span><br>
                ஓம் அஸ்மத் குருப்யோ நம: ஸ்ரீமான் வேங்கட நாதார்ய: கவிதார்க்கிக கேஸரி வேதாந்தாச்சார்ய
                வர்யோமே ஸந்நிதத்ததாம் ஸதாஹ்ருதி: குருப்ய: தத்குருப்யஸ்ச்ச நமோவாகம் அதீமஹே! வ்ரூணீமஹேச
                தத்ராத்யௌ தம்பதீ ஜகதாம்பதீ ஸ்வசேஷ பூதேநமயா ஸ்வீயை: ஸர்வ பரிச்சதை: ப்ரீதமாத்மாநம்
                தேவ: ப்ரக்ரமதே ஸ்வயம். <span style="color: Red">தென்கலை வடகலை பொது ஆரம்பம்:</span><br>
                ஓம் சுக்லாம்பரதரம் விஷ்ணும் சசிவர்ணம் சதுர்புஜம் ப்ரசன்னவதனம் த்யாயேத் ஸர்வ விக்நோபசாந்தயே
                ! யஸ்யத்வ்ரத வக்ராத்யா: பாரிஷத்யா: பரச்சதம் விக்னம் நிக்நந்தி சததம் விஷ்வக்ஸேநம்
                தமாச்ரயே! ஹரி: ஓம் தத்! (ப்ராசீனாவீதி - பூணல் வலம்)<br>
                ஸ்ரீ கோவிந்தா கோவிந்த கோவிந்தா அஸ்யஸ்ரீ பகவத: மஹா புருஷஸ்ய விஷ்ணோராக்ஞயா ப்ரவர்த்தமாநஸ்ய
                அத்ய ப்ரஹ்மண: த்விதீய பரார்த்தே ஸ்ரீஸ்வேதவராஹ கல்பே வைவஸ்த மந்வந்தரே கலியுகே ப்ரதமேபாதே
                ஜம்பூத்வீபே பாரதவர்ஷே பரதக்கண்டே ஸகாப்தே மேரோ: தக்ஷpணேபார்ச்வே அஸ்மிநு வர்த்தமாநே
                வ்யாவஹாரிகே ப்ரபவாதி ஷஷ்டி ஸம்வத்ஸராணாம் மத்யே பார்த்திப நாம ஸம்வத்ஸரே தக்ஷpணா யனே
                வர்ஷ ருதௌ கன்யா மாஸே க்ருஷ்ண பNக்ஷ .......(திதி)......(யா)யாம் புண்ய திதௌ வாசர:
                . . . .(வாரம்) . . . . . வாசரயுக்தாயாம் . (நக்ஷத்ரம்) . . . நக்ஷத்திர யுக்தாயாம்
                ஸ்ரீவிஷ்ணுயோக ஸ்ரீவிஷ்ணு கரண சுப யோக சுப கரண ஏவங்குண விசேஷண விசிஷ்டாயாம் அஸ்யாம்
                ...(திதி).....யாயாம் புண்ய திதௌ ஸ்ரீபகவதாக்ஞயா <span style="color: Red">வடகலை :</span>
                ஸ்ரீமந்நாராயண ப்ரீத்யர்த்தம் <span style="color: Red">தென்கலை :</span> பகவத் கைங்கர்யரூபம்
                (அப்பாவழி கோத்ரம், அப்பா, தாத்தா, கொள்ளு தாத்தா பெயர் சொல்லிக்கறது)<br>
                . . . . . . . . . . . . . . . . கோத்ராணாம்<br>
                . . . . . . . . . . . . . . . (1)<br>
                . . . . . . . . . . . . . . . (2)<br>
                . . . . . . . . . . . . . . . (3) சர்மணாம்<br>
                வசு ருத்ர ஆதித்ய ஸ்வரூபாணாம் அஸ்மது பித்ரு பிதாமஹ ப்ரபிதாமஹாணாம்<br>
                (அம்மாவழி கோத்ரம் - தாத்தா, கொள்ளு தாத்தா, எள்ளு தாத்தா பெயர்கள்)<br>
                . . . . . . . .கோத்ராணாம்<br>
                . . . . . . . . . . . . . . . . . (1)<br>
                . . . . . . . . . . . . . . . . .(2)<br>
                . . . . . . . . . . . . . . . . .(2)<br>
                . . . . . . . . . . . . . . . . .(2)<br>
                . . . . . . . . . . . . . . . . .(3)<br>
                வசு ருத்ர ஆதித்ய ஸ்வரூபாணாம் அஸ்மது மாதாமஹ மாது: பிதாமஹ மாது: ப்ரபிதாமஹாணாம் உபயவம்ச
                பித்ரூணாம், ஸபத்நீகாநாம் வர்க்கத்வய காருண்ய பித்ரூணாம் ச அக்ஷய்ய த்ருப்த்யர்த்தம்
                *ஸக்ருண் மஹாளய ச்ராத்தம் தில தர்ப்பண ரூபேண கரிஷ்யே!
                <br>
                <span style="color: Red">*அமாவாசைக்கு - தர்ச , மாதப்பிறப்புக்கு - மேஷ/கடக/துலா/மகர ஸம்க்ரமண,
                    ஸூர்ய க்ரஹணத்துக்கு - ஸூர்யோபராக, சந்த்ர க்ரஹணத்துக்கு - ஸோமோபராக என்று பெயரை
                    மாற்றிக் கொள்ளவும்.</span>
                <br>
                <span style="color: Red">இடுக்குப் பில்லை தெற்கே சேர்க்கறது.</span>
           
</div>
</mat-expansion-panel><mat-expansion-panel><mat-expansion-panel-header>
    ஸாத்விக த்யாகம்</mat-expansion-panel-header>
<div class="div3">
    <span style="color: Green">வடகலையார் மட்டும் : பகவாநேவ ஸ்வநியாம்ய ஸ்வரூபஸ்திதி ப்ருவ்ருத்தி
        ஸ்வசேஷத ஏகரஸேந அநேன ஆத்மநா கர்த்ரா ஸ்வகீயைஸ்ச்ச உபகரணை: ஸ்வாராதனைக ப்ரயோஜநாய பரமபுருஷ:
        ஸர்வசேஷி ஸர்வேச்வர: ஸ்ரீய:பதி: ஸ்வசேஷ பூதமிதம் திலதர்பணாக்யம் கர்ம ஸ்வஸ்மை ஸ்வப்ரீதயே
        பகவான் ஸ்வயமேவ காரயதி.</span><br>
        </div>
</mat-expansion-panel><mat-expansion-panel><mat-expansion-panel-header>ஸ்தல ப்ரோக்ஷணம்</mat-expansion-panel-header>
<div class="div3">
    <span style="color: Red">ஸ்தல ப்ரோக்ஷணம். (வேத வாக்கியங்கள் இட்டலைஸ்டு செய்யப்பட்டுள்ளது.
        )</span><br>
    <span style="font-style: italic; line-height: 1.8;font-weight: 550;">அபஹதா: - அசுரா: - ரக்ஷாகும்ஸி
        - பிசாசா: யேக்ஷயந்தி - ப்ருதிவீமநு - அந்யத்ரேத: - கச்சந்து - யத்ரைஷாம் - கதம்மமந:
        - உதீரதாம் - அவர - உத்பராஸ: - உந்மத்யமா: - பிதர: - ஸோம்யாஸ: - அஸும் - யஈயு: - அவ்ருகா:
        - ருதஜ்ஞா: - தேநோவந்து - பிதரோஹவேஷு. அபவித்ர: - பவித்ரோவா - ஸர்வாவஸ்தாம் - கதோபிவா
        - யஸ்மரேது - புண்டரீகாக்ஷம் ஸபாஹ்ய-ஆப்யந்தரசுசி:! பூர்புவஸ் ஸுவோ பூர்புவஸ்ஸுவோ பூர்புவஸ்
        ஸுவ: ஸ்ரீமதே புண்டரீகாக்ஷாய நம:</span><br>
    (எள்ளும் ஜலமும் தர்பணம் பண்ணும் இடத்தில் (தாம்பாளத்தில்) ப்ரோக்ஷிக்றது)
</div>
</mat-expansion-panel><mat-expansion-panel><mat-expansion-panel-header>
    பித்ரு வர்க்க ஆவாஹனம்</mat-expansion-panel-header>
<div class="div3">
    <span style="color: Red">பித்ரு வர்க்க புக்னத்தில் ஆவாஹனம்</span><br>
    <span style="color: Maroon; font-style: italic; font-size: 13pt">ஆயாத பிதர: - ஸோம்யாகம்பீரை:
        - பதிபி: - பூர்வ்யை: - ப்ரஜாம் - அஸ்மப்யம் - தத: - ரயிஞ்சா - தீர்காயுத்வஞ்சா - சதசாரதஞ்சா!</span>
    (அப்பாவழி கோத்ரம்). . . . . . கோத்ராநு<br>
    (அப்பாபெயர்) . . . . . . (1)<br>
    (தாத்தா பெயர்) . . . . . . . .(2)
    <br>
    (தாத்தாவுக்கு அப்பா பெயர்) ... . .. . . .. .(3) சர்மண:
    <br>
    வசு ருத்ர ஆதித்ய ஸ்வரூபாநு அஸ்மது பித்ரு பிதாமஹ ப்ரபிதாமஹாநு<br>
    <span style="color: Red">(அம்மா இருப்பவர்களுக்காக ‘/” பிந்தைய தகவல்கள் வழங்கப்பட்டுள்ளன.)</span><br>
    (அப்பாவழி கோத்ரம்). . . . .கோத்ரா:<br>
    .(அம்மா /பாட்டி பெயர்) . . . . . .(1). . (அப்பாவின் - ‘அம்மா”/’பாட்டி”). . . .(2).
    <br>
    (அப்பாவின் அப்பாவின் அம்மா / அப்பாவின் அப்பாவின் பாட்டி) . .(3) நாம்நீ:
    <br>
    வசு ருத்ர ஆதித்ய பத்நீ ஸ்வரூபா: அஸ்மது மாத்ரு பிதாமஹி ப்ரபிதாமஹீ (/ பிதாமஹி பிது:பிதாமஹி
    பிது: ப்ரபிதாமஹீ) ஸ்ச ஆவாஹயாமி!
    <br>
    <span style="color: Red">(கிழக்கே முதல் வரிசை புக்னத்தில் எள் சேர்க்கறது)</span>
    <br>
    <span style="color: Red">ஆஸனம்:</span><br>
    <span style="color: Maroon; font-style: italic; font-size: 13pt">ஸக்ருதாச்சின்னம் - பர்ஹி:
        - ஊர்ணாம்ருது- ஸ்யோநம் - பித்ருப்யஸ்த்வ- பராம்யஹம் - அஸ்மிநுஸீதந்துமே - பிதர:ஸோம்யா:
        - பிதாமஹா: ப்ரபிதாமஹாஸ்சா - அனுகைஸ்ஸஹ </span>
    <br>
    (அப்பாவழி கோத்ரம்). . . . . . கோத்ராணாம்
    <br>
    (அப்பாபெயர்) . .................. . (1)<br>
    (தாத்தா பெயர்) . . . . . . (2)
    <br>
    (தாத்தாவுக்கு அப்பா பெயர்) ... . . . . .. .(3) சர்மணாம்
    <br>
    வசு ருத்ர ஆதித்ய ஸ்வரூபாணாம் அஸ்மது பித்ரு பிதாமஹ ப்ரபிதாமஹாணாம் (அப்பாவழி கோத்ரம்).
    . . . .கோத்ராணாம்<br>
    .(அம்மா / பாட்டி பெயர்) . . . . . .(1). .
    <br>
    (அப்பாவின் அம்மா /அப்பாவின் பாட்டி). . .(2).
    <br>
    (அப்பாவின் அப்பாவின் அம்மா / அப்பாவின் அப்பாவின் பாட்டி) . .(3) நாம்நீநாம்
    <br>
    வசு ருத்ர ஆதித்ய பத்நீ ஸ்வரூபாணாம் அஸ்மது மாத்ரு பிதாமஹி ப்ரபிதாமஹீணாம்
    <br>
    (/பிதாமஹி பிது: பிதாமஹி பிது: ப்ரபிதாமஹீணாம்) ஸ்ச்ச இதமாஸனம் இதமர்ச்சனம். (எள் சேர்க்கறது)<br>
    <span style="color: Maroon; font-size: 13pt; font-style: italic">ஊர்ஜம் வஹந்தீ: - அம்ருதம்
        - க்ருத: - கீலாலம் - பரிஸ்ருதம் - ஸ்வதாஸ்த்த - தர்ப்பயதமே - அஸ்மத் பித்ரூநு.</span>
    <br>
    (கட்டை விரல் வழியாக தீர்த்தம் விடவேண்டியது)
</div>
</mat-expansion-panel><mat-expansion-panel><mat-expansion-panel-header>
    மாதாமஹாதி ஆவாஹனம்</mat-expansion-panel-header>
<div class="div3">
    <span style="color: red">மாதாமஹ வர்க்க புக்னத்தில் ஆவாஹனம்</span>
    <br>
    <span style="color: Maroon; font-style: italic; font-size: 13pt">ஆயாத மாது: பிதர: - ஸோம்யாகம்பீரை:
        - பதிபி: - பூர்வ்யை: - ப்ரஜாம் - அஸ்மப்யம் - ததத: - ரயிஞ்சா - தீர்காயுத்வஞ்சா -
        சதசாரதஞ்சா!</span><br>
    (அம்மாவழி கோத்ரம்). . . . . . கோத்ராநு<br>
    (அம்மாவின்அப்பாபெயர்) . . . . . .(1)<br>
    (அம்மாவின் தாத்தா பெயர்) . . . . . . .(2)
    <br>
    (அம்மாவின் தாத்தாவுக்கு அப்பா பெயர்) .(3) சர்மண:
    <br>
    வசு ருத்ர ஆதித்ய ஸ்வரூபாநு அஸ்மது மாதாமஹ - மாது: பிதாமஹ - மாது: ப்ரபிதாமஹாநு
    <br>
    (அம்மாவின் அம்மா இருப்பவர்களுக்காக‘/ ”பிந்தையதகவல்கள் )<br>
    (அம்மாவழி கோத்ரம்). . . . .கோத்ரா:<br>
    .(அம்மாவின் அம்மா /பாட்டி பெயர்) . . .(1). .
    <br>
    (அம்மாவின் பாட்டி / அம்மாவின் அப்பாவின் பாட்டி). . . . .(2).
    <br>
    (அம்மாவின் அப்பாவின் அப்பாவின் அம்மா /அம்மாவின் அப்பாவின் அப்பாவின் பாட்டி) . .(3)
    நாம்நீ:
    <br>
    வசு ருத்ர ஆதித்ய பத்நீ ஸ்வரூபா: அஸ்மது மாதாமஹி - மாது: பிதாமஹி - மாது: ப்ரபிதாமஹீ
    <br>
    (/ மாது: பிதாமஹி - மாது: பிது:பிதாமஹி - மாது: பிது: ப்ரபிதாமஹீ) ஸ்ச ஆவாஹயாமி!<br>
    (மேற்கே 3வது வரிசை புக்னத்தில் எள் சேர்க்கறது)<br>
    ஆஸனம்:<br>
    <span style="color: Maroon; font-style: italic; font-size: 13pt">ஸக்ருதாச்சின்னம் - பர்ஹி:
        - ஊர்ணாம்ருது- ஸ்யோநம் - பித்ருப்யஸ்ச்ச- பராம்யஹம் - அஸ்மிநுஸீதந்துமே - மாது: பிதர:ஸோம்யா:
        - மாது: பிதாமஹா: - மாது: ப்ரபிதாமஹாஸ்சா - அனுகைஸ்ஸஹ </span>
    <br>
    (அம்மாவழி கோத்ரம்) . . . . . கோத்ராணாம்<br>
    (அம்மாவின்அப்பாபெயர்) . . . . . .(1)
    <br>
    (அம்மாவின் தாத்தா பெயர்) . . . . . . . .(2)<br>
    (அம்மாவின் தாத்தாவுக்கு அப்பா பெயர்) .(3)<br>
    சர்மணாம் வசு ருத்ர ஆதித்ய ஸ்வரூபாநாம் அஸ்மது மாதாமஹ - மாது: பிதாமஹ - மாது: ப்ரபிதாமஹாநாம்
    <br>
    (அம்மாவழி கோத்ரம்). . . . .கோத்ராணாம்<br>
    .(அம்மாவின் அம்மா /பாட்டி பெயர்) . . . . . .(1). .<br>
    (அம்மாவின் பாட்டி /அம்மாவின் அப்பாவின் பாட்டி). . . . .(2).<br>
    (அம்மாவின் அப்பாவின் அப்பாவின் அம்மா /அம்மாவின் அப்பாவின் அப்பாவின் பாட்டி) . .(3)
    நாம்நீநாம்<br>
    வசு ருத்ர ஆதித்ய பத்நீ ஸ்வரூபாணாம் அஸ்மது மாதாமஹி - மாது: பிதாமஹி - மாது: ப்ரபிதாமஹீணாம்
    <br>
    (/ மாது: பிதாமஹி - மாது: பிது:பிதாமஹி - மாது: பிது: ப்ரபிதாமஹீணாம்) ஸ்ச்ச இதமாஸனம்
    இதமர்ச்சனம். (எள் சேர்க்கறது)<br>
    <span style="color: Maroon; font-style: italic; font-size: 13pt">ஊர்ஜம் வஹந்தீ: - அம்ருதம்
        - க்ருத: - கீலாலம் - பரிஸ்ருதம் - ஸ்வதாஸ்த்த - தர்ப்பயதமே - அஸமத் மாது: பித்ரூநு.
    </span>
    <br>
    (கட்டை விரல் வழியாக தீர்த்தம் விடவேண்டியது) 
    </div>
     </mat-expansion-panel><mat-expansion-panel><mat-expansion-panel-header>
    காருண்ய பித்ரு ஆவாஹனம் :</mat-expansion-panel-header>
<div class="div3">
    
    நடுவில் இரண்டு புக்னங்களை வைத்து பண்ணவேண்டும்.<br>
    <span style="color: Maroon; font-style: italic; font-size: 13pt">ஆயாத காருண்ய பிதர: -
        ஸோம்யா கம்பீரை: - பதிபி: - பூர்வ்யை: - ப்ரஜாம் - அஸ்மப்யம் - ததத: - ரயிஞ்ச - தீர்காயுத்வஞ்சா
        - சதசாரதஞ்சா! பித்ருவ்ய மாதுலாதி - ஸர்வாநு - ஸபத்நீகாநு - காருண்ய பித்ரூநு - ஆவாஹயாமி!</span><br>
    (மத்தியிலுள்ள புக்னத்தில் எள் சேர்க்கிறது)<br>
    <span style="color: Maroon; font-style: italic; font-size: 13pt">ஸக்ருதாச்சின்னம் - பர்ஹி:
        - ஊர்ணாம்ருது - ஸ்யோனம் - பித்ருப்யஸ்த்வா - பராம்யஹம் - அஸ்மின் - ஸீதந்துமே - காருண்ய
        பிதர: ஸோம்யா: - காருண்ய பிதாமஹா: - காருண்ய ப்ரபிதாமஹாஸ்ச்சா - அநுகைஸ்ஸஹா. </span>
    <br>
    பித்ருவ்ய மாதுலாதி வர்க்கத்வய காருண்ய பித்ரூணாம், காருண்ய பித்ருபத்நீநாம்ச்ச இதமாசனம்
    - இதமர்ச்சனம். (எள் சேர்க்கறது)<br>
    <span style="color: Maroon; font-style: italic">ஊர்ஜம் வஹந்தீ: - அம்ருதம் - க்ருதம்
        பய: - கீலாலம் - பரிச்ருதம் - ஸ்வதாஸ்த்த - தர்ப்பயதமே - காருண்ய பித்ரூநு.</span><br>
    (எள்ளும் ஜலமுமாக கட்டைவிரல் வழியாக நடு புக்னங்களில் விடவேண்டியது.)
</div>
</mat-expansion-panel><mat-expansion-panel><mat-expansion-panel-header>
    பித்ரு வர்க்க தர்ப்பணம்</mat-expansion-panel-header>
<div class="div3">
    பித்ரு வர்க்க புக்னத்தில் தர்ப்பணம்: (முழுவதும் அப்பா கோத்திரத்தைச் சொல்லவும்.)
    <br>
    <span style="color: Maroon; font-style: italic; font-size: 13pt">1. உதீரதாம் - அவர -
        உத்பராஸ: - உந்மத்யமா: - பிதர: - ஸோம்யாஸ: - அஸும் - யஈயு: - அவ்ருகா: - ருதஜ்ஞா: -
        தேநோவந்து - பிதரோ ஹவேஷு </span>
    <br>
    . . . கோத்ராநு . அப்பா பெயர் . சர்மண: வசு ரூபாநு அஸ்மத் பித்ரூநு ஸ்வதாநமஸ்தர்ப்பயாமி
    !
    <br>
    (ஒவ்வொரு தர்ப்பயாமிக்கும் கட்டைவிரல் வழியாக எள் ஜலம் விடவேண்டியது)
    <br>
    <span style="color: Maroon; font-style: italic; font-size: 13pt">2.அங்கிரஸோந: - பிதர:
        - நவக்வா: - அதர்வாண: - ப்ருகவ: - ஸோம்யாஸ: - தேஷாம் - வயம் - ஸுமதௌ - யஜ்ஞியாநாம்
        - அபிபத்ரே - ஸெளமனஸே - ஸ்யாமா!</span><br>
    . . . கோத்ராநு . அப்பா பெயர் . சர்மண: வசு ரூபாநு அஸ்மத் பித்ரூநு ஸ்வதாநமஸ்தர்ப்பயாமி
    !
    <br>
    <span style="color: Maroon; font-style: italic; font-size: 13pt">3. ஆயந்துந: - பிதர:
        - மநோஜவஸ: - அக்நிஷ்வாத்தா: - பதிபி: - தேவயானை: - அஸ்மிநு - யஜ்ஞே - ஸ்வதயாமதந்து
        - அதிப்ருவந்து - தேஅவந்து - அஸ்மாநு!</span><br>
    . . . கோத்ராநு . அப்பா பெயர் . சர்மண: வசு ரூபாநு அஸ்மத் பித்ரூநு ஸ்வதாநமஸ்தர்ப்பயாமி
    !
    <br>
    <span style="color: Maroon; font-style: italic; font-size: 13pt">4.ஊர்ஜம் வஹந்தீ: - அம்ருதம்
        - க்ருதம் பய: - கீலாலம் - பரிஸ்ருதம் - ஸ்வதாஸ்த்த - தர்ப்பயதமே - அஸ்மத் பித்ரூநு</span><br>
    . . . . கோத்ராநு . அப்பாவின் அப்பா பெயர் . சர்மண: ருத்ர ரூபாநு அஸ்மத் பிதாமஹாநு
    ஸ்வதாநமஸ்தர்ப்பயாமி !
    <br>
    <span style="color: Maroon; font-style: italic; font-size: 13pt">5. பித்ருப்ய: - ஸ்வதாவிப்ய:
        - ஸ்வதா நம: - பிதாமஹேப்ய: - ஸ்வதாவிப்ய: - ஸ்வதாநம: - ப்ரபிதாமஹேப்ய: - ஸ்வதாவிப்ய:
        - ஸ்வதாநம: - அக்ஷந்பிதர:!</span><br>
    . . . கோத்ராநு . அப்பாவின் அப்பா பெயர் . சர்மண: ருத்ர ரூபாநு அஸ்மத் பிதாமஹாநு ஸ்வதாநமஸ்தர்ப்பயாமி
    !
    <br>
    <span style="color: Maroon; font-style: italic; font-size: 13pt">6.யே சேஹா - பிதர: -
        யேசநேஹா - யாகு(ம்)ச்சா - வித்மயாநு - உசநா - ப்ரவித்மா - அக்நே - தாநுவேத்தா - யதிதே
        - ஜாதவேத: - தயா - ப்ரத்தம் - ஸ்வதயாமதந்து</span><br>
    . . . கோத்ராநு . அப்பாவின் அப்பா பெயர் . சர்மண: ருத்ர ரூபாநு அஸ்மத் பிதாமஹாநு ஸ்வதாநமஸ்தர்ப்பயாமி
    !
    <br>
    <span style="color: Maroon; font-style: italic; font-size: 13pt">7.மதுவாதா: - ருதாயதே
        - மதுக்க்ஷரந்தி - ஸிந்தவ: - மாத்வீர்ந: - ஸந்த்வோஷதீ: !</span><br>
    . . . கோத்ராநு . அப்பாவின் தாத்தா பெயர் . சர்மண: ஆதித்ய ரூபாநு அஸ்மத் ப்ரபிதாமஹாநு
    ஸ்வதாநமஸ்தர்ப்பயாமி !
    <br>
    <span style="color: Maroon; font-style: italic; font-size: 13pt">8.மதுநக்தம் - உதோஷஸி
        - மதுமது - பார்த்திவம் - ரஜ: - மது த்யௌ: - அஸ்துந: பிதா</span><br>
    . . கோத்ராநு . அப்பாவின் தாத்தா பெயர் . சர்மண: ஆதித்ய ரூபாநு அஸ்மத்ப்ரபிதாமஹாநு
    ஸ்வதாநமஸ் தர்ப்பயாமி !
    <br>
    <span style="color: Maroon; font-style: italic; font-size: 13pt">9.மதுமாந்ந: - வநஸ்பதி:
        - மதுநாநு - அஸ்துஸூர்ய: - மாத்வீ: - காவோபவந்துந:!</span><br>
    . . . கோத்ராநு . அப்பாவின் தாத்தா பெயர் . சர்மண: ஆதித்ய ரூபாநு அஸ்மத் ப்ரபிதாமஹாநு
    ஸ்வதாநமஸ்தர்ப்பயாமி !<br>
    . . . . கோத்ரா: . . . . நாம்நீ: வசு பத்நி ரூபா: அஸ்மத் மாத்ரு: / பிதாமஹீ: (அம்மா
    /பாட்டி) ஸ்வதாநமஸ்தர்ப்பயாமி (3 தரம்)<br>
    . . . . கோத்ரா: . . . நாம்நீ: ருத்ர பத்நி ரூபா: அஸ்மத் பிதாமஹீ: / பிது: பிதாமஹீ:
    (பாட்டி /கொள்பாட்டி) ஸ்வதாநமஸ்தர்ப்பயாமி (3 தரம்)<br>
    . . . கோத்ரா: . . . . நாம்நீ: ஆதித்ய பத்நி ரூபா: அஸ்மத் ப்ரபிதாமஹீ: / பிது: ப்ரபிதாமஹீ:
    (கொள்பாட்டி/எள்பாட்டி) ஸ்வதாநமஸ்தர்ப்பயாமி (3 தரம்)<br>
    ஜ்ஞாதாஜ்ஞாத பித்ரூநு ஸ்வதாநமஸ் தர்ப்பயாமி! (3 தரம்)<br>
    ஜ்ஞாதாஜ்ஞாத பித்ரூ பத்நீ: ஸ்வதாநமஸ்தர்ப்பயாமி! (3 தரம்)<br>
    <br>
    <span style="color: Maroon; font-style: italic; font-size: 13pt">ஊர்ஜம் வஹந்தீ: - அம்ருதம்
        - க்ருதம்பய: - கீலாலம் - பரிஸ்ருதம் - ஸ்வதாஸ்த்த - தர்ப்பயதமே - அஸ்மத் பித்ரூநு!</span><br>
    த்ருப்யத த்ருப்யத த்ருப்யத. (எள் ஜலம் அப்ரதக்ஷிணமாகச் சுற்றி விடவேண்டியது)
</div>
</mat-expansion-panel><mat-expansion-panel><mat-expansion-panel-header>
    மாதாமஹ வர்க்க தர்ப்பணம்</mat-expansion-panel-header>
<div class="div3">
    <span style="color: Red">மாதாமஹ வர்க்க புக்னத்தில் தர்ப்பணம்: முழுவதும் அம்மாவின் அப்பா
        கோத்திரத்தைச் சொல்லவும்.</span><br>
    <br>
    <span style="color: Maroon; font-style: italic; font-size: 13pt">1.உதீரதாம் - அவர - உத்பராஸ:
        - உந்மத்யமா: - பிதர: - ஸோம்யாஸ: - அஸும் - யஈயு: - அவ்ருகா: - ருதஜ்ஞா: - தேநோவந்து
        - பிதரோ ஹவேஷு</span><br>
    . . . . கோத்ராநு . அம்மாவின் அப்பா பெயர் . சர்மண: வசு ரூபாநு அஸ்மத் மாதாமஹாநு ஸ்வதாநமஸ்தர்ப்பயாமி
    !
    <br>
    <span style="color: Maroon; font-style: italic; font-size: 13pt">2.அங்கிரஸோந: - பிதர:
        - நவக்வா: - அதர்வாண: - ப்ருகவ: - ஸோம்யாஸ: - தேஷாம் - வயம் - ஸுமதௌ - யஜ்ஞியாநாம்
        - அபிபத்ரே - ஸெளமனஸே - ஸ்யாமா!</span><br>
    . . . கோத்ராநு . அம்மாவின் அப்பா பெயர் . சர்மண: வசு ரூபாநு அஸ்மத் மாதாமஹாநு ஸ்வதாநமஸ்தர்ப்பயாமி
    !
    <br>
    <span style="color: Maroon; font-style: italic; font-size: 13pt">3.ஆயந்துந: - பிதர: -
        மநோஜவஸ: - அக்நிஷ்வாத்தா: - பதிபி: - தேவயானை: - அஸ்மிநு - யஜ்ஞே - ஸ்வதயாமதந்து -
        அதிப்ருவந்து - தேஅவந்து - அஸ்மாநு!</span><br>
    . . . கோத்ராநு . அம்மாவின் அப்பா பெயர் . சர்மண: வசு ரூபாநு அஸ்மத் மாதாமஹாநு ஸ்வதாநமஸ்தர்ப்பயாமி
    !
    <br>
    <span style="color: Maroon; font-style: italic; font-size: 13pt">4.ஊர்ஜம் வஹந்தீ: - அம்ருதம்
        - க்ருத: - கீலாலம் - பரிஸ்ருதம் - ஸ்வதாஸ்த்த - தர்ப்பயதமே - அஸமத் பித்ரூநு</span><br>
    . . . . கோத்ராநு . அம்மாhவின் தாத்தா பெயர் . சர்மண: ருத்ர ரூபாநு அஸ்மத் மாது: பிதாமஹாநு
    ஸ்வதாநமஸ்தர்ப்பயாமி !
    <br>
    <span style="color: Maroon; font-style: italic; font-size: 13pt">5. பித்ருப்ய: - ஸ்வதாவிப்ய:
        - ஸ்வதா நம: - பிதாமஹேப்ய: - ஸ்வதாவிப்ய: - ஸ்வதாநம: - ப்ரபிதாமஹேப்ய: - ஸ்வதாவிப்ய:
        - ஸ்வதாநம: - அக்ஷந்பிதர:</span><br>
    . . . கோத்ராநு . அம்மாவின் தாத்தா பெயர் . சர்மண: ருத்ர ரூபாநு அஸ்மத் மாது: பிதாமஹாநு
    ஸ்வதாநமஸ்தர்ப்பயாமி !
    <br>
    <span style="color: Maroon; font-style: italic; font-size: 13pt">6.யே சேஹா - பிதர: -
        யேசநேஹா - யாகு(ம்)ச்சா - வித்மயாநு - உசநா - ப்ரவித்மா - அக்நே - தாநுவேத்தா - யதிதே
        - ஜாதவேத: - தயா - ப்ரத்தம் - ஸ்வதயாமதந்து</span><br>
    . . . கோத்ராநு . அம்மாவின் தாத்தா பெயர் . சர்மண: ருத்ர ரூபாநு அஸ்மத் மாது: பிதாமஹாநு
    ஸ்வதாநமஸ்தர்ப்பயாமி !
    <br>
    <span style="color: Maroon; font-style: italic; font-size: 13pt">7.மதுவாதா: - ருதாயதே
        - மதுக்க்ஷரந்தி - ஸிந்தவ: - மாத்வீர்ந: - ஸந்த்வோஷதீ: !</span><br>
    . . . கோத்ராநு . அம்மாhவின் தாத்தாவின் அப்பா பெயர் . சர்மண: ஆதித்ய ரூபாநு அஸ்மத்
    மாது: ப்ரபிதாமஹாநு ஸ்வதாநமஸ்தர்ப்பயாமி !
    <br>
    <span style="color: Maroon; font-style: italic; font-size: 13pt">8.மதுநக்தம் - உதோஷஸி
        - மதுமது - பார்த்திவம் - ரஜ: - மது த்யௌ: - அஸ்துந: பிதா!</span><br>
    . . . கோத்ராநு . அம்மாhவின் தாத்தாவின் அப்பா பெயர் . சர்மண: ஆதித்ய ரூபாநு அஸ்மத்
    மாது: ப்ரபிதாமஹாநு ஸ்வதாநமஸ்தர்ப்பயாமி !
    <br>
    <span style="color: Maroon; font-style: italic; font-size: 13pt">9.மதுமாந்ந: - வநஸ்பதி:
        - மதுநாநு - அஸ்துஸூர்ய: - மாத்வீ: - காவோபவந்துந:!</span><br>
    . . . கோத்ராநு . அம்மாவின் தாத்தாவின் அப்பா பெயர் . சர்மண: ஆதித்ய ரூபாநு அஸ்மத்
    மாது: ப்ரபிதாமஹாநு ஸ்வதாநமஸ்தர்ப்பயாமி !<br>
    . . . . கோத்ரா: . . . நாம்நீ: வசு பத்நி ரூபா: அஸ்மத் மாதாமஹீ: (அம்மாவின் அம்மா)
    ஸ்வதாநமஸ்தர்ப்பயாமி (3 தரம்)<br>
    . . . . . கோத்ரா: . . . நாம்நீ: ருத்ர பத்நி (வசு பத்நி) ரூபா: அஸ்மத் மாது: பிதாமஹீ:
    (அம்மாவின் பாட்டி) ஸ்வதாநமஸ்தர்ப்பயாமி (3 தரம்)<br>
    . . கோத்ரா: . . . நாம்நீ: ஆதித்ய பத்நி (ருத்ர பத்நி)ரூபா: அஸ்மத் மாது: ப்ரபிதாமஹீ:
    (அம்மாவின்கொள்பாட்டி) ஸ்வதாநமஸ் தர்ப்பயாமி (3 தரம்)<br>
    . . கோத்ரா: . . . நாம்நீ: ஆதித்ய பத்நி ரூபா: அஸ்மத் மாது: ப்ர ப்ரபிதாமஹீ: (அம்மாவின்
    அப்பாவின் கொள்பாட்டி) ஸ்வதாநமஸ் தர்ப்பயாமி (3 தரம்)<br>
    ஜ்ஞாதாஜ்ஞாத மாது: பித்ரூநு ஸ்வதாநமஸ் தர்ப்பயாமி! (3 தரம்)<br>
    ஜ்ஞாதாஜ்ஞாத மாது: பித்ரூ பத்நீ: ஸ்வதாநமஸ் தர்ப்பயாமி! (3 தரம்)<br>
    <br>
    <span style="color: Maroon; font-style: italic; font-size: 13pt">ஊர்ஜம் வஹந்தீ: - அம்ருதம்
        - க்ருதம்பய: - கீலாலம் - பரிஸ்ருதம் - ஸ்வதாஸ்த்த - தர்ப்பயதமே - அஸ்மத் மாது: பித்ரூநு!</span><br>
    த்ருப்யத த்ருப்யத த்ருப்யத.<br>
    காருண்ய பித்ருக்களுக்கு நடுவில் உள்ள புக்னங்களில் தர்ப்பணம்:<br>
    பித்ருவ்ய மாதுலாதி - வர்கத்வய காருண்ய பித்ரூன் - ஸ்வதாநமஸ் - தர்ப்பயாமி (3 தரம்)<br>
    பித்ருவ்ய மாதுலாதி - வர்கத்வய காருண்ய பித்ரு பத்நீ: ஸ்வதாநமஸ் தர்ப்பயாமி! (3 தரம்)<br>
    ஜ்ஞாதாஜ்ஞாத வர்க்கத்வய காருண்ய பித்ரூன் ஸ்வதாநமஸ் தர்ப்பயாமி ! (3 தரம்)<br>
    ஜ்ஞாதாஜ்ஞாத வர்க்கத்வய காருண்ய பித்ரு பத்நீ: ஸ்வதாநமஸ் தர்ப்பயாமி! (3 தரம்)<br>
    <br>
    <span style="color: Maroon; font-style: italic; font-size: 13pt">ஊர்ஜம் வஹந்தீ: - அம்ருதம்
        - க்ருதம்பய: - கீலாலம் - பரிஸ்ருதம் - ஸ்வதாஸ்த்த - தர்ப்பயதமே - காருண்ய பித்ரூநு!</span><br>
    த்ருப்யத த்ருப்யத த்ருப்யத.
</div>
</mat-expansion-panel><mat-expansion-panel><mat-expansion-panel-header>
    காருண்ய பித்ரு தர்ப்பணம்</mat-expansion-panel-header>
<div class="div3">
    காருண்ய பித்ருக்களுக்கு நடுவில் உள்ள புக்னங்களில் தர்ப்பணம்:<br>
    பித்ருவ்ய மாதுலாதி - வர்கத்வய காருண்ய பித்ரூன் - ஸ்வதாநமஸ் - தர்ப்பயாமி (3 தரம்)<br>
    பித்ருவ்ய மாதுலாதி - வர்கத்வய காருண்ய பித்ரு பத்நீ: ஸ்வதாநமஸ் தர்ப்பயாமி! (3 தரம்)<br>
    ஜ்ஞாதாஜ்ஞாத வர்க்கத்வய காருண்ய பித்ரூன் ஸ்வதாநமஸ் தர்ப்பயாமி ! (3 தரம்)<br>
    ஜ்ஞாதாஜ்ஞாத வர்க்கத்வய காருண்ய பித்ரு பத்நீ: ஸ்வதாநமஸ் தர்ப்பயாமி! (3 தரம்)<br>
    <br>
    <span style="color: Maroon; font-style: italic; font-size: 13pt">ஊர்ஜம் வஹந்தீ: - அம்ருதம்
        - க்ருதம்பய: - கீலாலம் - பரிஸ்ருதம் - ஸ்வதாஸ்த்த - தர்ப்பயதமே - காருண்ய பித்ரூநு!</span><br>
    த்ருப்யத த்ருப்யத த்ருப்யத. 
</div>
</mat-expansion-panel><mat-expansion-panel><mat-expansion-panel-header>
    உபஸ்தானம் 3 ப்ரதக்ஷிணம்</mat-expansion-panel-header>
<div class="div3">     
    
    உபஸ்தானம் : (உபவீதி - கையைக் கூப்பிக் கொண்டு தாம்பாளத்தை
    3 ப்ரதக்ஷிணம்.):
    <br>
    <span style="color: Maroon; font-style: italic; font-size: 13pt">நமோவ: - பிதரோ ரஸாயா<br>
        நமோவ: - பிதர: - சூஷ்மாயா<br>
        நமோவ: - பிதரோ ஜீவாயா<br>
        நமோவ: - பிதர: - ஸ்வதாயை<br>
        நமோவ: - பிதரோமந்யவே<br>
        நமோவ: - பிதரோ கோராயா - பிதரோ நமோவ:<br>
        ய ஏதஸ்மிந் - லோகேஸ்தா<br>
        யுஷ்மாகும்ஸ்தேநு - யேஸ்மிந்லோகே - மாம்தேநு - ய ஏதஸ்மிந் லோகேஸ்தா - யூயம்தேஷாம் -
        வஸிஷ்டா பூயாஸ்தா - யேஸ்மிந் லோகே அஹம் தேஷாம் - வஸிஷ்டோ பூயாஸம்.</span>
    <br>
    என்று சொல்லி ஸேவித்து அபிவாதி பண்ணவேண்டியது.<br>

</div>
</mat-expansion-panel><mat-expansion-panel><mat-expansion-panel-header>
    3 வர்க யதாஸ்தானம்</mat-expansion-panel-header>
<div class="div3">   
    உட்கார்ந்து கொண்டு ப்ராசீனாவீதி. எள் எடுத்துக்கொண்டு.
    <br>
    <span style="color: Maroon; font-style: italic; font-size: 13pt">வாஜே வாஜே - அவத வாஜிந:
        - நோதநேஷு - விப்ரா: - அம்ருதா: - ருதஜ்ஞா: - அஸ்யமத்வ: - பிபதா - மாதயத்வம் - த்ருப்தாயாதா
        - பதிபி: - தேவயாநை: - தேவதாப்ய: - பித்ருப்யஸ்ச்சா - மஹாயோகிப்ய: - நமஸ்வதாயை - ஸ்வாஹாயை
        - நித்யமேவ - நமோ நம:</span><br>
    (அப்பாவழி) .கோத்ராநு . . . . . .(1). . . . . . .(2). . . . . . .(3) சர்மண:<br>
    வசு ருத்ர ஆதித்ய ஸ்வரூபாநு அஸ்மது பித்ரு பிதாமஹ ப்ரபிதாமஹாநு<br>
    . . . கோத்ரா: . . . . . . .(1) . . . . . .(2). . . . . . . . .(3) நாம்நீ:<br>
    வசு ருத்ர ஆதித்ய பத்நீ ஸ்வரூபா: அஸ்மது மாத்ரு பிதாமஹி ப்ரபிதாமஹீஸ்ச
    <br>
    (அல்லது பிதாமஹி பிது: பிதாமஹி பிது: ப்ரபிதாமஹீஸ்ச்ச) யதாஸ்தானம் ப்ரதிஷ்டாபயாமி !<br>
    (கிழக்கு புக்னத்தில் எள் சேர்க்கறது) . . . .கோத்ராநு . . . .(1). . . . . .(2). .
    . . . . . .(3) சர்மண:
    <br>
    வசு ருத்ர ஆதித்ய ஸ்வரூபாநு அஸ்மது மாதாமஹ மாது: பிதாமஹ மாது: ப்ரபிதாமஹாநு
    <br>
    . . . .கோத்ரா: . .(1). . . .(2). . . .(3) நாம்நீ: வசு ருத்ர ஆதித்ய பத்நீ ஸ்வரூபா:
    <br>
    அஸ்மது மாதாமஹி மாது: பிதாமஹி மாது: ப்ரபிதாமஹீஸ்ச யதாஸ்தானம் ப்ரதிஷ்டாபயாமி!
    <br>
    (மேற்கு புக்னத்தில் எள் சேர்க்கறது.)<br>
    பித்ருவ்ய மாதுலாதி வர்க்கத்வய காருண்ய பித்ரூநு காருண்ய பித்ருபத்நீஸ்ச்ச யதாஸ்தானம்
    ப்ரதிஷ்டாபயாமி!
    <br>
    (நடுவில் உள்ள புக்னத்தில் எள் சேர்க்கவேண்டியது.)<br>
    3 வர்க்க புக்னங்களையும் பிரித்துக் கொள்ளவேண்டியது. தர்ப்ப நுனிகள் கட்டைவிரல் புறமாக
    இருக்கும்படி வைத்துக் கொண்டு
    <br>
    சிறிது எள் சேர்த்துக் கொண்டு பின் வரும் மந்திரம் முடியும்போது ஜலம் சேர்த்து எல்லாவற்றையும்
    தாம்பாளத்தில் கட்டைவிரல் புறமாக சேர்த்துவிட வேண்டியது.<br>
    ஏஷாநு - நஸுத: - நப்ராதா - நபந்து: - நஅந்ய கோத்ரீண: - தேத்ருப்திம் - அகிலாயாந்து
    - மயா த்யக்தை: - குசோதகை: - த்ருப்யத - த்ருப்யத - த்ருப்யத<br>
    உபவீதி பண்ணிக்கொண்டு பவித்ரம் பிரித்துப்போட்டு ஆசமனம்.
</div>
</mat-expansion-panel><mat-expansion-panel><mat-expansion-panel-header>
    ஸாத்விக த்யாகம்</mat-expansion-panel-header>
<div class="div3">
    <span style="color: Green">வடகலை : பகவாநேவ ... உத்திஸ்ய சக்ருண் மஹாளய ச்ராத்தம் திலதர்பணாக்யம்
        கர்ம ஸ்வஸ்மை ஸ்வப்ரீதயே பகவாந் ஸ்வயமேவ காரிதவாநு</span>
    <br>
</div>
</mat-expansion-panel><mat-expansion-panel><mat-expansion-panel-header>
    காயேனவாசா பொது</mat-expansion-panel-header>
<div class="div3">
    <span style="color: Red">இரு கலையாரும்:</span> காயேநவாசா மநஸே இந்த்ரியைர்வா புத்யா
    ஆத்மநாவா ப்ருஹ்ருதே: ஸ்வபாவாது கரோமி யத்யது ஸகலம் பரஸ்மை ஸ்ரீமந் நாராயணாயேதி ஸமர்ப்பயாமி!
    <br>
    ஸர்வம் ஸ்ரீக்ருஷ்ணார்ப்பணமஸ்த்து அச்சுயுதப்ரீயதாம்!
    <br>
</div>
</mat-expansion-panel><mat-expansion-panel><mat-expansion-panel-header>
    விண்ணப்பம் (வேண்டுகோள்)</mat-expansion-panel-header>
<div class="div3">
    <span style="color: Maroon">குறிப்பு:- காருண்ய பித்ருக்களுக்கான விஷயங்களை நீக்கிவிட்டால்
        இதை அமாவாசை மற்றும் மாதப் பிறப்பு தர்பணங்களுக்கு உபயோகப்படுத்திக் கொள்ளலாம்.
        <br>
        புரியாத விஷயங்கள் இருந்தால் https://www.brahminsnet.com/forums/ இணைய தளத்தில் 
        உறுப்பினராகி, தங்கள் கேள்விகளைக் கேட்டு அவ்வப்போது தெளிவு பெறலாம். <br>
        ஸேவை நோக்கில் செய்யப்படும் இதற்கு கட்டணங்கள் எதுவும் முக்கிய மில்லை.
        
         </span>
</div>
</mat-expansion-panel>
</mat-accordion>
<div class="div3" style="font-size: 24px; line-height: 1.8;">
श्री:
श्रीभगवदाज्ञया श्रीमन्नारायण प्री.....म्।
...... गोत्राणां  १........... २ .......... ३............... शर्मणां वसुरद्र आदित्य स्वरूपाणां अस्मत् पितृ पितामह प्रपितामहाणां
..........गोत्राणां १...........२..........३............ नाम्नीनां 
मातृ पितामहि प्रपितामहीनां (पितामहि, पितु:पितामहि, पितु: प्रपितामहीनां) 

........... गोत्राणां १.........२..........३............ शर्मणां 
वसुरद्र आदित्य स्वरूपाणां मातामह, मातु: पितामह, मातु: प्रपितामहाणां 
..........गोत्राणां १.............२............३......... नाम्नीनां 
वसुरद्र आदित्य स्वरूपाणां मातामही, मातु: पितामही, मातु: प्रपितामहीनां उभयवंश पिऋृणां च अक्षय्य तृप्त्यर्थं 
अमावाश्या / ... शंक्रमण / सोमोपराक / सूर्योपराक / अष्टका / अन्वष्टका  पुण्यकाले 
..... श्राद्धं तिलतर्पण रूपेण अद्य करिष्ये ।

उपवीति - सात्विक त्यागम्।
भगवानेव स्वनियाम्य स्वरूपस्थिति प्रवृत्ति स्वशेषत एकरसेन अनेन आत्मना कर्त्रा स्वकीयैश्च उपकरणै: स्वाराधनैक प्रयोजनाय परमपुरुष: सर्वशेषि सवेश्वर: श्रिय:पति: स्वशेषभूतमिदं ........ पुण्यकाले ....... श्राद्धं तिलतर्पणाख्यं स्वस्मै स्वप्रीतये भगवान् स्वयमेव कारयति।

प्राचीनावीति।
अपॅहता:   -   असुॅरा:   -   रक्षॅाँसि   -   पि॒शा॒चा:   -    येक्षयॅन्ति   -   पृ॒थि॒वीमनुॅ   -   अ॒न्यत्रेतॅ:   -   ग॒च्छ॒न्तु॒   -   यत्रैष॑ां   -   ग॒त॒ंमनॅ:।   उदीॅरतां   -   अवॅर॒   -   उत्परॉस:   -   उन्मॅध्य॒मा:   -   पितरॅ:   -   सो॒म्यासॅ:।   अस्॑ाुं   -   यई॒यु:   -   अ॒वृ॒का:   -   ऋ॒त॒ज्ञा:   -   तेनोॅवन्तु  -   पि॒तरो॒हवेॅ्षु।

अपवित्र: पवित्रोवा सर्वावस्थां गतोऽपिवा। यस्समरेत् पुण्डरीकाक्षं सबाह्य आभ्यन्तर: शुचि:। 
ओं भूर्भुवस्सुवोभूर्भुवस्सुवोभूर्भुवस्सुवॅ:। श्रीमते पुण्डरीकाक्षाय नम:।

आवाहनम् - पितृ वर्गम् ।
आयॉत   -   पितर:   -   सो॒म्या॒:   -   ग॒म्भी॒रै:   -   प॒थिभॅि:   -   प॒ूर्व्यै:  -   प्॒रजां   -    अ॒स्मभ्य॑ं   -   द॒द॒त॒:   -   र॒यिंच   -   दीर्घायुत्वंच   -   शतशारदंच।
........गोत्रान्  १............२...............३............... शर्मण: वसु, रद्र, आदित्य स्वरूपान् अस्मत् पितृ पितामह प्रपितामहान् 
...........गोत्रा: १.............२.............३............. नाम्नी: वसु रुद्र आदित्य स्वरूपा: अस्मत् मातृ, पितामही, प्रपितामहीश्च 
(पितामही, पितु: पितामही, पितु: प्रपितामहीश्च) आवाहयामि।
सकृदाच्छिन्नं   -   बर्हि:   -   उूर्णामृदु   -   स्योनं   -   पितृभ्यस्त्वा   -   भराम्यहम्।   अस्मिन्   -  सीदन्तुमे   -   पितर:   -   सोम्या:   -   पितामहा:   -   प्रपितामहाश्च   -   अनुगैस्सह।
..........गोत्राणां १...........२...........३.............शर्मणां वसु रद्र आदित्य स्वरूपाणां अस्मत् पितृ पितामह प्रपितामहाणां
..........गोत्राणां १..........२...........३...........नाम्नीनां वसु रद्र आदित्य स्वरूपाणां अस्मत् मातृ पितामही प्रपितामहीनां च (पितामही प्रपितामही पित: प्रपितामहीनां च) इदमासनम्।

उूर्जं॒वहॅन्ती:   -   अ॒मृतं   -   घृ॒तंपयॅ:   -   कीलालं   -   परिस्रृतं   -   स्वधास्थ   -   तर्पयतमे   -   पित्रून्।

आवाहनम् - मातामह वर्गम् ।
आयात   -   मातु:पितर:   -   सोम्या:   -   गम्भीरै:   -   पथिभि:   -   पूर्व्यै:  -   प्रजां   -    अस्मभ्यं   -   ददत:   -   रयिंच   -   दीर्घायुत्वंच   -   शतशारदंच।
........गोत्रान्  १............२...............३............... शर्मण: वसु, रद्र, आदित्य स्वरूपान् अस्मत् मातामह  मातु:पितामह  मातु:प्रपितामहान् 
...........गोत्रा: १.............२.............३............. नाम्नी: वसु रुद्र आदित्य स्वरूपा: अस्मत् मातामही मातु:पितामही  मातु प्रपितामहीश्च आवाहयामि।
सकृदाच्छिन्नं   -   बर्हि:   -   उूर्णामृदु   -   स्योनं   -   पितृभ्यस्त्वा   -   भराम्यहम्।   अस्मिन्   -  सीदन्तुमे   -   पितर:   -   सोम्या:   -   पितामहा:   -   प्रपितामहाश्च   -   अनुगैस्सह।
..........गोत्राणां १...........२...........३.............शर्मणां वसु रद्र आदित्य स्वरूपाणां अस्मत् मातामह  मातु:पितामह   मातु:प्रपितामहाणां
..........गोत्राणां १..........२...........३...........नाम्नीनां वसु रद्र आदित्य स्वरूपाणां अस्मत् मातामही  मातु:पितामही  मातु:प्रपितामहीनां च इदमासनम्।

उूर्जं॒वहॅन्ती:   -   अ॒मृतं   -   घृ॒तंपयॅ:   -   कीलालं   -   परिस्रृतं   -   स्वधास्थ   -   तर्पयतमे   -   मातु:पित्रून्।

तर्पणम् - पितृ वर्गम् ।
उदीॅरतां   -   अवॅर॒   -   उत्परॉस:   -   उन्मॅध्य॒मा:   -   पितरॅ:   -   सो॒म्यासॅ:।   असुं॑  -   यई॒यु:   -   अ॒वृ॒का:   -   ऋ॒त॒ज्ञा:   -   तेनोॅवन्तु  -   पि॒तरो॒हवेॅ्षु।


.............गोत्रान् ......................शर्मण: 
वसुरूपान् अस्मत् पित्त्रून् स्वधानमस्तर्पयामि।
अंगॅिरसोन:   -   पि॒तरॅ:   -   नवॅग्वा:   -   अथॅर्वाण:   -   भृगॅव:   -   सो॒म्यासॅ:   -   तेषां॑  -   व॒यं   -   सु॒मतौ  -   य॒ज्ञियॉनां   - अपॅिभद्रे     -   सौ॒म॒न॒सेस्यॅाम।
.............गोत्रान् ......................शर्मण: 
वसुरूपान् अस्मत् पित्त्रून् स्वधानमस्तर्पयामि।
आयॅन्तुन:   -   पि॒तरॅ:   -   मनोॅजवस:   -   अ॒ग्नि॒ष्वा॒त्ता:   -   प॒थिभॅि:   -   दे॒व॒यानै:   -   अ॒स्मिन्   -   य॒ज्ञे   -   स्व॒धया॒मदॅन्तु   -   अधॅिब्रुवन्तु   -   तेअॅवन्तु  -   अ॒स्मान्।
.............गोत्रान् ......................शर्मण: 
वसुरूपान् अस्मत् पित्त्रून् स्वधानमस्तर्पयामि।

उूर्जं॒वहॅन्ती:   -   अ॒मृतं   -   घृ॒तंपयॅ:   -   की॒लालं   -   परि॒स्रृतं   -   स्व॒धास्थॅ   -   त॒प॒र्य॒त॒मे   -   पि॒त्रून्।
.............गोत्रान् ......................शर्मण: 
रुद्ररूपान् अस्मत् पितामहान् स्वधानमस्तर्पयामि।
पि॒तृभ्यॅ:  -   स्व॒धाविभ्यॅ:   -   स्व॒धानमॅ:   -   पि॒ता॒महेभ्यॅ:  -   स्व॒धाविभ्यॅ:   -   स्व॒धानमॅ:   -   प्रपॅितामहेभ्य:   -   स्व॒धाविभ्यॅ:   -   स्व॒धानमॅ:   -   अक्षन्ॅ   -   पि॒तरॅ:।
.............गोत्रान् ......................शर्मण: 
रुद्ररूपान् अस्मत् पितामहान् स्वधानमस्तर्पयामि।

येचे॒ह   -   पि॒तरॅ:   -   येच॒नेह   -   याँश्चॅ   -   वि॒द्मयान्   -   उ॒च॒न   -   प्रॅवि॒द्म   -   अग्ने॒    -   तान्व॑ेत्थ   -   यदि॒ते   -   जा॒त॒व॒ेद॒:   -   तय॑ा   -   प्र॒त्तं   -   स्व॒धयॉमदन्ति।
.............गोत्रान् ......................शर्मण: 
रुद्ररूपान् अस्मत् पितामहान् स्वधानमस्तर्पयामि।

मधु॒वाता॑:   -   ऋ॒ता॒य॒ते   -   मधॅुक्षरन्ति   -   सिन्धॅव:   -   माध्वी॑र्न:   -   स॒न्त्वोषॅधी:।
.............गोत्रान् ......................शर्मण: 
आदित्य रूपान् अस्मत् प्रपितामहान् स्वधानमस्तर्पयामि।
मधु॒नक्त्॑ां   -   उ॒तोषॅसि   -   मधुॅमत्   -   पर्थ्ॅािवं   -   रजॅ:   मध्॒ाुद्यौ:   -  अ॒स्त॒ुन॒:पि॒ता।
.............गोत्रान् ......................शर्मण: 
आदित्य रूपान् अस्मत् प्रपितामहान् स्वधानमस्तर्पयामि।
मधुॅमान्न:  -   वन॒स्पतॅि:   -   मधुॅमान्   -   अ॒स्त॒ुसूर्यॅ:   -  माद्व॑ी:   -  गावॉेभवन्तु:।
.............गोत्रान् ......................शर्मण: 
आदित्य रूपान् अस्मत् प्रपितामहान् स्वधानमस्तर्पयामि।
..........गोत्रा: ...............नाम्नी: अस्मत् मात्त्रू: (पितामही:)
						स्वधानमस्तर्पयामि। (त्रि:)
..........गोत्रा: ...............नाम्नी: अस्मत् पितामही: (पितु:पितामही:)
						स्वधानमस्तर्पयामि। (त्रि:)
..........गोत्रा: ...............नाम्नी: अस्मत् प्रपितामही: (पितु:प्रपितामही:)
						स्वधानमस्तर्पयामि। (त्रि:)
ज्ञाताज्ञात पित्त्रून् स्वधानमस्तर्पयामि। (त्रि:)
ज्ञाताज्ञात पितृपत्नी: स्वधानमस्तर्पयामि। (त्रि:)
उूर्जं॒वहॅन्ती:   -   अ॒मृतं   -   घृ॒तंपयॅ:   -   कीलालं   -   परिस्रृतं   -   स्वधास्थ   -   तर्पयतमे   -   अस्मत् पित्रून्। तृप्यत। तृप्यत। तृप्यत।

तर्पणम् - मातामह वर्गम् ।
उदीॅरतां   -   अवॅर॒   -   उत्परॉस:   -   उन्मॅध्य॒मा:   -   पितरॅ:   -   सो॒म्यासॅ:।   अस्॑ाुं   -   यई॒यु:   -   अ॒वृ॒का:   -   ऋ॒त॒ज्ञा:   -   तेनोॅवन्तु  -   पि॒तरो॒हवेॅ्षु।


.............गोत्रान् ......................शर्मण: 
वसुरूपान् अस्मत् मातामहान् स्वधानमस्तर्पयामि।
अंगॅिरसोन:   -   पि॒तरॅ:   -   नवॅग्वा:   -   अथॅर्वाण:   -   भृगॅव:   -   सा॒ेम्यासॅ:   -   तेष॑ां   -   व॒यं   -   स॒ुमतौ   -   य॒ज्ञियॉनां   -   अॅपिभ॒द्रे   -   सौ॒म॒न॒सेस्यॅाम।
.............गोत्रान् ......................शर्मण: 
वसुरूपान् अस्मत् मातामहान् स्वधानमस्तर्पयामि।
आयॅन्तुन:   -   पि॒तरॅ:   -   मनोॅजवस:   -   अ॒ग्नि॒ष्वा॒त्ता:   -   प॒थिभॅि:   -   द॒ेव॒यानै:   -   अ॒स्मिन्   -   य॒ज्ञे   -   स्व॒धया॒मदॅन्तु   -   अधॅिबु्रवन्तु   -   तेअॅवन्तु   -   अ॒स्मान्।
.............गोत्रान् ......................शर्मण: 
वसुरूपान् अस्मत् मातामहान् स्वधानमस्तर्पयामि।

उूर्जं॒वहॅन्ती:   -   अ॒मृतं   -   घ॒ृतंपयॅ:   -   की॒लालं   -   परि॒स्रृतं   -   स्व॒धास्थॅ   -   त॒प॒र्य॒त॒मे   -   पि॒त्रून्।
.............गोत्रान् ......................शर्मण: 
रुद्ररूपान् अस्मत् मातु:पितामहान् स्वधानमस्तर्पयामि।
पि॒तृभ्यॅ:  -   स्व॒धाविभ्यॅ:   -   स्व॒धानमॅ:   -   पि॒ता॒महेभ्यॅ:  -   स्व॒धाविभ्यॅ:   -   स्व॒धानमॅ:   -   प्रपॅितामहेभ्य:   -   स्व॒धाविभ्यॅ:   -   स्व॒धानमॅ:   -   अक्षन्ॅ   -   पि॒तरॅ:।
.............गोत्रान् ......................शर्मण: 
रुद्ररूपान् अस्मत् मातु:पितामहान् स्वधानमस्तर्पयामि।

येचे॒ह   -   पि॒तरॅ:   -   येच॒नेह   -   याँश्चॅ   -   वि॒द्मयान्   -   उ॒च॒न   -   प्रॅवि॒द्म   -   अग्ने॒    -   तान्व॑ेत्थ   -   यदि॒ते   -   जा॒त॒व॒ेद॒:   -   तय॑ा   -   प्र॒त्तं   -   स्व॒धयॉमदन्ति।
.............गोत्रान् ......................शर्मण: 
रुद्ररूपान् अस्मत् मातु:पितामहान् स्वधानमस्तर्पयामि।

मधु॒वाता॑:   -   ऋ॒ता॒य॒ते   -   मधॅुक्षरन्ति   -   सिन्धॅव:   -   माध्वी॑र्न:   -   स॒न्त्वोषॅधी:।
.............गोत्रान् ......................शर्मण: 
आदित्य रूपान् अस्मत् मातु:प्रपितामहान् स्वधानमस्तर्पयामि।
मधु॒नक्त्॑ां   -   उ॒तोषॅसि   -   मधुॅमत्   -   पर्थ्ॅािवं   -   रजॅ:   मध्॒ाुद्यौ:   -  अ॒स्त॒ुन॒:पि॒ता।
.............गोत्रान् ......................शर्मण: 
आदित्य रूपान् अस्मत् मातु: प्रपितामहान् स्वधानमस्तर्पयामि।
मधुॅमान्न:  -   वन॒स्पतॅि:   -   मधुॅमान्   -   अ॒स्त॒ुसूर्यॅ:   -  माद्व॑ी:   -  गावॉेभवन्तु:।
.............गोत्रान् ......................शर्मण: 
आदित्य रूपान् अस्मत् मातु: प्रपितामहान् स्वधानमस्तर्पयामि।
..........गोत्रा: ...............नाम्नी: अस्मत् मातामही:
						स्वधानमस्तर्पयामि। (त्रि:)
..........गोत्रा: ...............नाम्नी: अस्मत् मातु: पितामही: 
						स्वधानमस्तर्पयामि। (त्रि:)
..........गोत्रा: ...............नाम्नी: अस्मत् मातु: प्रपितामही: 
						स्वधानमस्तर्पयामि। (त्रि:)
ज्ञाताज्ञात मातु: पित्त्रून् स्वधानमस्तर्पयामि। (त्रि:)
ज्ञाताज्ञात मातु: पितृपत्नी: स्वधानमस्तर्पयामि। (त्रि:)
उूर्जंवहन्ती:   -   अमृतं   -   घृतंपय:   -   कीलालं   -   परिस्रृतं   -   स्वधास्थ   -   तर्पयतमे   -   अस्मत् मातु:पित्रून्। तृप्यत। तृप्यत। तृप्यत।
नमोव: पितरो रसाय।
नमोव: पितरो शुष्माय।
नमोव: पितरो जीवाय।
नमोव: पितरस्वथयै।
नमोव: पितरोमन्यवे।
नमोव: पितरो घोराय।
पितरो नमोव:। यएतस्मिन् लोकेस्थ। युष्माँस्तेनु। येऽस्मिल्लोके मांतेनु।
यएतस्मिन् ल्लोकेस्थ। यूयंतेषांव्वसिष्ठो भूयास्त। येस्मिल्लोके अहंतेषाम्।
वसिष्ठो भूयासम्।
वाजेवाजे   - अवतवाजिन:   -   नोधनेषु   -   विप्रा:   -   अमृता:   -   अस्यमध्व:   -   पिबत   -   मादयध्वं   -   तृप्तायात   -   पथिभि:   -   देवयानै:।

उपवीति ।
देवताभ्य:   पितृभ्यच्छ   महायोेगिभ्य:   एवच   नमस्वधायै   स्वाहायै   नित्यमेव नमोनम:।
प्रणम्य।  अभिवद्म।   
प्राचीनावीति।

यथास्थानम्।
........गोत्रान्  १............२...............३............... शर्मण: वसु, रद्र, आदित्य स्वरूपान् अस्मत् पितृ पितामह प्रपितामहान् 
...........गोत्रा: १.............२.............३............. नाम्नी: वसु रुद्र आदित्य स्वरूपा: अस्मत् मातृ, पितामही, प्रपितामहीश्च 
(पितामही, पितु: पितामही, पितु: प्रपितामहीश्च) यथास्थानं प्रतिष्ठापयामि।

........गोत्रान्  १............२...............३............... शर्मण: वसु, रद्र, आदित्य स्वरूपान् अस्मत् मातामह  मातु:पितामह  मातु:प्रपितामहान् 
...........गोत्रा: १.............२.............३............. नाम्नी: वसु रुद्र आदित्य स्वरूपा: अस्मत् मातामही मातु:पितामही  मातु प्रपितामहीश्च यथास्थानं प्रतिष्ठापयामि।

येषान् नसुत:  नप्राता  न बन्तु:  नान्य गोत्रीण: तेतृप्तिं अघिलायान्तु मयात्यक्तै: कुशोदकै:।





</div>`;

const YajurTarpanamPage = () => {
  return (
    <div className="vaideekam-page-container w-full max-w-4xl mx-auto p-4 md:p-6 pb-24">
      <SEO title="யஜூர் தர்பணம் - Ahobilam" />
      <div 
        className="vaideekam-content bg-white p-6 rounded-xl shadow-sm border border-green-100/50"
        dangerouslySetInnerHTML={{ __html: HTML_CONTENT }} 
      />
    </div>
  );
};

export default YajurTarpanamPage;
